<template>
    <div>
      <data-table :service="EmailConfigService"
                  :entity="entity"
                  :columns="columns"
                  :disablePermissionChecks="true"
                  operations="add,edit"
                  operations-align="right"
                  ref="table">
        <template v-slot:domain="{row}">
          {{row.provider_domain}}
        </template>
        <template v-slot:status="{row}">
          <status-badge :status="row.config_status"></status-badge>
        </template>

        <template v-slot:default="{row}">
          <base-switch @click.native.stop="" :value="row.default" @input="val => onDefaultChange(row, val)"></base-switch>
        </template>

        <template slot="extra-buttons" slot-scope="{row, index}">
          <base-button v-if="!row.default"
                       class="float-right ml-1"
                       outline
                       @click.stop="() => $refs.table.onDelete(row, index)"
                       type="danger"
                       icon size="sm">
            <i class="far fa-trash-alt"></i>
          </base-button>
        </template>
      </data-table>
    </div>
</template>
<script>
  import EmailConfigService from 'src/services/EmailConfigService'
  import entities from 'src/config/entities'

  export default {
    name: 'email-configuration',
    data() {
      return {
        EmailConfigService,
        entity: entities.EMAIL_CONFIG
      }
    },
    computed: {
      columns() {
        return  [
          {
            prop: "domain",
            label: this.$t('settings.emailConfiguration.list.domain'),
            minWidth: "150px",
            sortable: true
          },
          {
            prop: "status",
            label: this.$t('settings.emailConfiguration.list.status'),
            minWidth: "150px",
            sortable: true
          },
          {
            prop: "default",
            label: this.$t('settings.emailConfiguration.list.default'),
            minWidth: "150px",
            sortable: true
          }
        ]
      }
    },
    methods: {
      async onDefaultChange(row, val) {
        if (val) {
          await this.$confirm('Are you sure ?', {
            message: 'Changing the default state, will make this configuration as default for all emails that are sent.'
          })
        }

        let data = {
          ...row,
          provider_password: undefined,
          default: val
        }
        await EmailConfigService.update(data.id, data)
        this.$refs.table.getTableData()
      }
    }
  }
</script>
<style>
</style>
